import cuepointVisibilitySaga from "./cuepointVisibilitySaga";
import inactivitySaga from "./inactivitySaga";
import loadStorySaga from "./loadStorySaga";
import controlNotifications from "./userNotifySaga";
import adResetSaga from "./adResetSaga";

export default function* rootSaga() {
  yield [
    adResetSaga(),
    controlNotifications(),
    cuepointVisibilitySaga(),
    inactivitySaga(),
    loadStorySaga(),
  ];
}
